import { useTranslation } from 'react-i18next';
import { TicketCard } from './TicketCard';

const styles = {
  empty: { color: '#94A3B8', textAlign: 'center', padding: '2rem 0', fontSize: '0.95rem' },
  list: { display: 'flex', flexDirection: 'column', gap: '0.75rem' },
};

export function QueueList({ entries, onSkip, onFinish }) {
  const { t } = useTranslation();
  if (!entries.length) {
    return <p style={styles.empty}>{t('queueList.empty')}</p>;
  }
  return (
    <div style={styles.list}>
      {entries.map((entry) => (
        <TicketCard key={entry.ticketUuid} entry={entry} onSkip={onSkip} onFinish={onFinish} />
      ))}
    </div>
  );
}
